import { SearchTravelModes } from '@/modules/Search/types'

export const DATE_FORMAT = 'dd/MM/yyyy'
export const TRAVEL_MODES: Array<SearchTravelModes> = [
  SearchTravelModes.Flight,
  SearchTravelModes.Car,
  SearchTravelModes.Hotel,
]
